import {
  ComplaintsNotesDocument,
  CreateComplaintsNoteDocument,
  CreateComplaintsNoteMutation,
  CreateComplaintsNoteMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateComplaintsNote = () => {
  const [executeMutation, { loading }] = useMutation(CreateComplaintsNoteDocument, {
    extractorFn: (data: CreateComplaintsNoteMutation) =>
      data.complaintsMutations.createComplaintsNote,
  })

  const createComplaintsNote = async (variables: CreateComplaintsNoteMutationVariables) => {
    return executeMutation({
      variables,
      refetchQueries: [ComplaintsNotesDocument],
      awaitRefetchQueries: true,
    })
  }

  return {
    createComplaintsNote,
    loading,
  }
}
